import { TruckTypeEnum } from '@/types/graphql/schemaTypes';
import { SelectOption } from '@/types/types';
import i18n from '@/plugins/i18n';

export function truckTypeOptions(): SelectOption<string>[] {
  return [
    TruckTypeEnum.consolidated,
    TruckTypeEnum.self_loader,
    TruckTypeEnum.lowbed_semi,
    TruckTypeEnum.high_flatbed,
    TruckTypeEnum.any_2t,
    TruckTypeEnum.powergate_2t,
    TruckTypeEnum.refrigerated_2t,
    TruckTypeEnum.crane_2t,
    TruckTypeEnum.wing_2t,
    TruckTypeEnum.flat_2t,
    TruckTypeEnum.any_4t,
    TruckTypeEnum.powergate_4t,
    TruckTypeEnum.refrigerated_4t,
    TruckTypeEnum.crane_4t,
    TruckTypeEnum.wing_4t,
    TruckTypeEnum.flat_4t,
    TruckTypeEnum.any_10t,
    TruckTypeEnum.powergate_10t,
    TruckTypeEnum.refrigerated_10t,
    TruckTypeEnum.crane_10t,
    TruckTypeEnum.wing_10t,
    TruckTypeEnum.flat_10t,
    TruckTypeEnum.flat_trailer_20t,
    TruckTypeEnum.wing_trailer_20t
  ].map((val: TruckTypeEnum) => {
    return { value: val, label: i18n.t(`truckType.${val}`).toString() };
  });
}
